// extracted by mini-css-extract-plugin
module.exports = {"activity-tree-list":"TasksList_activity-tree-list__IYDWD"};